module.exports = __webpack_public_path__ + "static/digipadala-customer-a02686a37b0a660e1d6945a6e186395c.png";